import {
  Text,
  withDatasourceCheck,
  NextImage,
  Field,
  ImageField,
  LinkField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'src/hooks/helpers';
import AbrdnButton from 'components/Generic/Buttons/AbrdnButton';
import { useSitecoreContext } from 'hooks/useSitecoreContext';

type Fields = {
  title?: Field<string>;
  description?: Field<string>;
  cta?: LinkField;
  icon?: ImageField;
};

type SectionHeadingProps = ComponentProps & {
  fields: Fields;
};

const SectionHeading = ({ fields, rendering }: SectionHeadingProps): JSX.Element => {
  const { anchorId, backgroundClass } = useHelpers(rendering);
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = sitecoreContext.pageEditing;

  const sectionType = rendering?.params?.type;
  const titleExist = !!fields?.title?.value;
  const descriptionExist = !!fields?.description?.value;
  const ctaExist = !!fields?.cta?.value?.text;

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      className={`default-section-padding ${backgroundClass}`}
    >
      <div className="container">
        {sectionType === 'H2' && (
          <div className="row mb-2 d-flex justify-content-center">
            <div className="col-12 col-md-8">
              {(isExperienceEditor || titleExist) && (
                <Text tag="h2" field={fields.title} className="background-to-change" />
              )}
            </div>
          </div>
        )}
      </div>

      <div className="row d-flex d-flex justify-content-center">
        <div className="col-12 col-md-8 d-flex flex-column align-items-start">
          {sectionType === 'H3' && (
            <div className="mb-2 d-flex align-items-center">
              <NextImage
                field={fields.icon}
                width="100"
                height="64"
                className="section-heading-image me-4 background-to-change"
              />
              {(isExperienceEditor || titleExist) && (
                <Text field={fields.title} tag="h3" className="background-to-change" />
              )}
            </div>
          )}
          {(isExperienceEditor || descriptionExist) && (
            <Text
              tag="p"
              field={fields.description}
              className="body-default description text-grey background-to-change"
            />
          )}
          {((sectionType === 'H3' && ctaExist) || isExperienceEditor || ctaExist) && (
            <AbrdnButton
              buttonType="primary"
              showExternalIcon={false}
              replaceWithSlot={false}
              linkField={fields.cta}
            >
              <em className="bi-arrow-right ms-1" aria-hidden="true" />
            </AbrdnButton>
          )}
        </div>
      </div>
    </section>
  );
};

export default withDatasourceCheck()<SectionHeadingProps>(SectionHeading);
